module.exports = __webpack_public_path__ + "static/media/icon-score-1-scale-5.d9416407.svg";